import { connect } from 'react-redux';
import { usePageViewEvents as usePageViewEventsImport } from '../../../../../../core/Analytics/usePageViewEvents';
import { OauthStoreDescription } from '../../../../../../stores/oauth-store';

import { ScreenWrapper } from '../../../../../atoms/ScreenWrapper/ScreenWrapper';
import { PageView } from '../../../../../../models/analytics';
import { applicationParameters } from '../../../../../../utilities/application-parameters';
import { SubmitCredentialsBaseProps } from '../../types';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../../../stores/redux-store';
import { useSelectedProvider } from '../../../../../App/ProviderContainer/useSelectedProvider';
import { LegalDisclaimer as LegalDisclaimerDefault } from '../../../../../molecules/LegalDisclaimer/LegalDisclaimer';

export const SubmitCredentialsScreenBasePresenter: React.ComponentType<
  SubmitCredentialsBaseProps & PropsFromRedux
> = ({
  Header,
  Form,
  LegalDisclaimer = LegalDisclaimerDefault,
  personalIdentifier,
  userId,
  oauthDescription,
  usePageViewEvents = usePageViewEventsImport,
  ...state
}) => {
  const { selectedProvider: provider } = useSelectedProvider();
  const { clientName, clientUrl, scopesDescriptionsList } = oauthDescription;

  usePageViewEvents({
    pageView: PageView.SUBMIT_CREDENTIALS_SCREEN,
  });

  const username = applicationParameters.get('username');

  return (
    <ScreenWrapper data-testid="addCredentialsWrapper">
      <Header
        provider={provider}
        pageView={PageView.SUBMIT_CREDENTIALS_SCREEN}
        onBack={undefined}
      />

      <Form
        fixedValue={personalIdentifier || username}
        provider={provider}
        userId={userId}
        clientName={clientName}
        clientUrl={clientUrl}
        scopesDescriptionsList={scopesDescriptionsList}
        {...state}
      />

      <LegalDisclaimer provider={provider} pageView={PageView.SUBMIT_CREDENTIALS_SCREEN} />
    </ScreenWrapper>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    credentialsError: state.credentials.error,
    isClientVerified: state.oauth.description?.verified,
    userId: state.user.user?.id,
    userHintId: state.user.idHint,
    isCredentialsLoading: state.credentials.loading,
    personalIdentifier: state.session.data?.personalIdentifier,
    sourceAccountNumber: state.session.data?.sourceAccountNumber,
    oauthDescription: state.oauth.description as OauthStoreDescription,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const SubmitCredentialsBase = connector(SubmitCredentialsScreenBasePresenter);
